import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import quizThumb from '../../assets/images/quiz-default.jpg';
// import Sidebar from "../components/dashboard/clinicianSidebar";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import parse from "react-html-parser";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
// import SideMenu from "./student/SideMenu";

import SessionPopup from "../../pages/SessionPopup";
let { lambda, appname } = window.app
const Result = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [selected, setSelected] = useState({});
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(false);
    const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState([]);
    const [items, setItems] = useState([]);
    const [success, setSuccess] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(true);
    const [quizzes, setQuizzes] = useState([]);
    const [quizResultData, setQuizResultData] = useState({});
    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)
    useEffect(() => {
        GetQuizInfo()
    }, [])

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);
    const columns = [
        {
            name: 'DIAGNOSE',
            selector: row => row?.caseDetails?.diagnosis || "",
        },
        {
            name: 'YOUR ANSWER',
            cell: row => (
                <span
                    className={row.isCorrect ? "correct" : "wrong error"}
                >
                    {row.answer}
                </span>
            )
        },
        {
            name: 'ACTUAL ANSWER',
            selector: row => row?.adminAnswer || "",
        }
    ];


    // const GetQuizInfo = async () => {
    //     try {
    //         const response = await tmdbApi.quizInfo(id);
    //         const allCases = response?.result?.[0]?.cases || [];

    //         setQuizzes(response?.result?.[0]);

    //         // Flatten all answers with their parent case info
    //         const allAnswers = allCases.flatMap(singleCase => {
    //             let correctCount = 0;

    //             return (singleCase.answers || [])
    //                 .filter(answer => typeof answer.isCorrect === 'boolean')
    //                 .map(answer => {
    //                     correctCount++;

    //                     return {
    //                         ...answer,
    //                         caseDetails: correctCount === 1 ? singleCase.caseDetails : "",
    //                         adminAnswer: singleCase.adminAnswer,
    //                     };
    //                 });
    //         });



    //         setQuizData(allAnswers);
    //         console.log("Flattened Answers", allAnswers);
    //         console.log("quizData?.[0]?.modulefiles?.[0]?.sourcepath", response?.result?.[0]?.modulefiles?.[0]?.sourcepath)

    //         setcontentLoaded(true);
    //     } catch (err) {
    //         console.log("error", err);
    //         setcontentLoaded(true);
    //     }
    // };
    const GetQuizInfo = async () => {
        try {
            setIsLoading(true); // ✅ START LOADER

            const response = await tmdbApi.quizInfo(id);
            const allCases = response?.result?.[0]?.cases || [];

            setQuizzes(response?.result?.[0]);

            const allAnswers = allCases.flatMap(singleCase => {
                let correctCount = 0;

                return (singleCase.answers || [])
                    .filter(answer => typeof answer.isCorrect === 'boolean')
                    .map(answer => {
                        correctCount++;
                        return {
                            ...answer,
                            caseDetails: correctCount === 1 ? singleCase.caseDetails : "",
                            adminAnswer: singleCase.adminAnswer,
                        };
                    });
            });

            setQuizData(allAnswers);

        } catch (err) {
            console.log("error", err);
        } finally {
            setIsLoading(false); // ✅ STOP LOADER
        }
    };

    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }
    const handleBack = () => {

        console.log('kirann babu', state.moduleType)
        if (state.moduleType === "fellowship") {
            navigate('/fellowshipmodules');
        } else {
            navigate('/usermoduleslibrary');
        }


    }
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>

            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                {/* Start right Content here  */}
                <div className="main-content user-management student-result-page" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="wrapper quiz_page result student_result">
                                <div className="form_block">
                                    {/* <div className="welcome">
                        <h3>Congratulations!</h3>
                        <p>You have completed the quiz!</p>
                    </div> */}

                                    <div className="quiz_info d-flex justify-content-between align-items-center">
                                        <div className="d-flex result-img-title ">
                                            <div className="d-flex align-items-center">
                                                {/* <div className="img">
                                                    {quizData?.[0]?.caseDetails?.files && quizData?.[0].caseDetails?.files.length > 0 ?
                                                        <img src={imageCloudfront +( quizData?.[0]?.caseDetails?.files[0]?.sourcepath || quizData?.[0]?.caseDetails?.files[0]?.filepath) ?.replace(/ /g, "%20") + `?auto=compress,format&width=125`} />
                                                        : <img src={quizThumb + `?auto=compress,format&width=125`} />}
                                                </div> */}

                                                <div className="img">
                                                    {/* {quizData?.[0]?.caseDetails?.files && quizData?.[0].caseDetails?.files.length > 0 ?
                                                        <img src={imageCloudfront?.replace(/\/$/, "") +( quizData?.[0]?.caseDetails?.files[0]?.thumbnailUrl) ?.replace(/ /g, "%20") + `?auto=compress,format&width=125`} />
                                                        : <img src={quizThumb + `?auto=compress,format&width=125`} />} */}
                                                    {imageCloudfront && quizzes?.modulefiles?.[0]?.sourcepath ? (
                                                        <img
                                                            src={
                                                                imageCloudfront?.replace(/\/$/, '') +
                                                                '/' +
                                                                quizzes?.modulefiles?.[0]?.sourcepath.replace(/ /g, '%20') +
                                                                '?auto=compress,format&width=125'
                                                            }
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <img
                                                            src={quizThumb + '?auto=compress,format&width=125'}
                                                            alt=""
                                                        />
                                                    )}

                                                </div>
                                                <div>
                                                    <h3>{quizData?.name}</h3>
                                                    <div className="date">
                                                        <p>{quizData?.startDate && moment(new Date(quizData?.startDate)).format('DD MMM, YYYY')}</p>

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="d-grid gap-0 info_center">
                                                <h2 className="card-title" id="breadcrumb-title">{quizzes?.moduleName}</h2>
                                                <div className="score">
                                                    <p>Score:</p>
                                                    <div className="score_count ">
                                                        <p>{quizzes?.moduleScore}<span>/</span>{quizzes?.caseCount}</p>
                                                        {/* <p>{123}<span>/</span>{150}</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            {/* <button className=" border_btn fill_btn" onClick={()=>handleReports(quizResultData?.quizid)}>Summary </button> */}

                                            {/* <button className=" border_btn" onClick={handleBack}> <span className="material-symbols-outlined mr-10"> arrow_back </span> Back</button> */}
                                            <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">
                                                back
                                            </a>
                                        </div>
                                    </div>

                                </div>
                                <div className="question_block">


                                    <DataTable
                                        // key={keyForRerender}
                                        // title=""
                                        columns={columns}
                                        className="table-responsive result_table"
                                        keyField='questionid'
                                        data={quizData}
                                        direction="auto"
                                        highlightOnHover
                                        fixedHeaderScrollHeight="300px"
                                        // pagination
                                        responsive
                                        persistTableHead
                                        // selectableRowsVisibleOnly
                                        striped
                                        // selectableRowsHighlight
                                        // selectableRows
                                        subHeaderAlign="right"
                                        defaultSortField="name"
                                        subHeaderWra
                                        // noDataComponent={customNoRecords()}
                                        // paginationTotalRows={quizzes?.length}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        // paginationPerPage={rowsPerPage}
                                        // paginationDefaultPage={currentPageNew}
                                        // paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                        sortFunction={customSort}

                                        // paginationComponentOptions={{
                                        //     rowsPerPageText: 'Per page:',
                                        //     rangeSeparatorText: 'of',
                                        //     noRowsPerPage: false,
                                        //     selectAllRowsItem: false,
                                        //     selectAllRowsItemText: 'All',
                                        // }}

                                        progressPending={isLoading}
                                        progressComponent={<TableLoader />}
                                    />


                                    {!isLoading && quizData.length === 0 && customNoRecords()}







                                </div>
                            </div>
                            {/* result */}
                        </div>
                    </div>
                    <Footer id="footer" />
                </div>
            </div>
        </>
    );
};
export default Result;